// import React, { useState } from "react";
// import CountUp from "react-countup";

// const Stats = ({ animated_numbers }) => {

//   return (
//     <>
//       <section className='max-w-7xl mx-auto bg-[#FEF8F6] my-5 py-10 rounded-xl  text-white'>
//         <div className='px-4 sm:px-6 lg:px-8'>
//           <div className='grid grid-cols-2 md:grid-cols-4 gap-8 text-center'>
//             {animated_numbers.map((animated_number, index) => (
//               <div key={index}>
//                 <div className='text-[25px] md:text-[38px] font-bold text-[#050B20] mb-2'>
//                   {animated_number.number}
//                 </div>
//                 <div className='text-[15px] font-normal text-[#050B20]'>
//                   {animated_number.label}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className='max-w-7xl mx-auto bg-[#FEF8F6] my-5 py-10 rounded-xl text-white'>
//         <div className='px-4 sm:px-6 lg:px-8'>
//           <div className='grid grid-cols-2 md:grid-cols-4 gap-8 text-center'>
//             {animated_numbers.map((animated_number, index) => (
//               <div key={index}>
//                 <div className='text-[25px] md:text-[38px] font-bold text-[#050B20] mb-2'>
//                   <CountUp end={animated_number.number} duration={4} />
//                 </div>
//                 <div className='text-[15px] font-normal text-[#050B20]'>
//                   {animated_number.label}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Stats;

import React, { useEffect, useState } from "react";

const extractParts = (value) => {
  // Extract number and remaining text
  const match = value.match(/([\d,.]+)(.*)/);
  if (!match) return { number: 0, suffix: "" };

  const numeric = match[1].replace(/,/g, ""); // Remove commas
  const suffix = match[2].trim();
  const number = parseFloat(numeric);
  return { number: isNaN(number) ? 0 : number, suffix };
};

const Stats = ({ animated_numbers }) => {
  const [counts, setCounts] = useState(
    animated_numbers.map((item) => ({
      current: 0,
      ...extractParts(item.number),
    }))
  );

  useEffect(() => {
    const intervals = counts.map((item, idx) => {
      const step = Math.ceil(item.number / 40); // control speed
      return setInterval(() => {
        setCounts((prevCounts) =>
          prevCounts.map((count, i) => {
            if (i !== idx) return count;
            const next = Math.min(count.current + step, item.number);
            return { ...count, current: next };
          })
        );
      }, 50);
    });

    return () => intervals.forEach(clearInterval);
  }, []);

  return (
    <section className=' mx-auto bg-[#414042]  py-10  text-white'>
      <div className='px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto'>
        <div className='grid grid-cols-2 md:grid-cols-4 gap-8 text-center'>
          {counts.map((item, index) => (
            <div key={index}>
              <div className='text-[25px] md:text-[30px] font-bold text-white mb-2'>
                {item.current.toLocaleString()} {item.suffix}
              </div>
              <div className='text-[16px]  text-[#ffffff]'>
                {animated_numbers[index].label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
